// When setting focus programmatically, in some cases, the next "keyup" event
// will propagate to the next focused element and cause unintended behavior,
// such as closing a menu when you were closing a selectro. With this function,
// we can prevent the next "keyup" event.
export const preventNextKey = ({
  key,
  eventName,
}: {
  key: string;
  eventName: 'keyup' | 'keydown';
}): void => {
  const preventNextKeyup = (event: KeyboardEvent): void => {
    if (event.key === key) {
      event.preventDefault();
      event.stopPropagation();
      document.removeEventListener(eventName, preventNextKeyup, true);
    }
  };

  document.addEventListener(eventName, preventNextKeyup, true);
};
